import React, {useEffect, useRef} from "react";
// import styles from "./ProductModal.module.scss";
import {products} from "components/homePanels/l_customWraps/CustomWraps.data";
import {useDispatch, useSelector} from "react-redux";
import wrapStyles from "components/homePanels/l_customWraps/CustomWraps.module.scss";
import NavToggle from "components/icons/navToggle/NavToggle";
import {buttonClick} from "utils/Helpers";

const ProductModal = (props) => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch();
    const title = useRef();

    function selectProduct(product) {

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                product: product
            }
        });

    }

    function removeDesign(){


        if(props.refocus) props.refocus.focus()

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                design: null
            }
        });
    }

    useEffect(()=>{

        if(accessible.productModal !== (wrapSelection.design && !wrapSelection.product) && props.active){

            if(title.current) title.current.focus();

            dispatch({ type: "SET_ACCESSIBLE",
                payload: {
                    ...accessible,
                    productModal: wrapSelection.design && !wrapSelection.product
                }
            });

        }

    }, [wrapSelection, accessible, dispatch, props.active])



    return !(wrapSelection.design && !wrapSelection.product) ? <></> : (
        <div className={wrapStyles.modalWrapper}>
            <div role={'dialog'} className={wrapStyles.modalContent}>
                <h4 ref={title} tabIndex={-1}>Select your Surface</h4>
                <div className={wrapStyles.items}>
                    {products.map((product, i) => (
                        <div tabIndex={0} role={'button'} aria-label={product.name.replace('&nbsp;', ' ')} onKeyDown={buttonClick} key={i} className={`${wrapStyles.item} ${wrapStyles.device}`} onClick={()=>selectProduct(product)}>
                            <img src={product.image} alt={product.name.replace('&nbsp;', ' ')}/>
                            <div aria-hidden={true} dangerouslySetInnerHTML={{__html:product.name}}/>
                        </div>
                    ))}
                </div>
                <div tabIndex={0} role={'button'} aria-label={'Close design modal'} onKeyDown={buttonClick} className={wrapStyles.close} onClick={()=>removeDesign()}><NavToggle closeOnly={true}/></div>
            </div>
        </div>
    );

}

export default ProductModal;
